import React, { useState } from "react";
import InputField from "common/customInputField";
import Button from "react-bootstrap/Button";
import Modal from "common/modal";
import DataTable from "common/desktopDataTable";
import warning from "svg/warning.svg";
import { useDispatch } from "react-redux";
import { parentLookupHeaders } from "utils/common";
import { showSpinner, hideSpinner } from "store/slices/spinner";
import { parentLookupFetch } from "services/parentLookup.service";
import { displayDesktopRowItem } from "../desktopDataTable/utils";
import CustomTooltip from "common/tooltip";

const ParentLookup = ({ mobileView, modalDisplayCallback, parentSelectionCallback }) => {
  const dispatch = useDispatch();
  const [parentLookupData, setParentLookupData] = useState({
    childAccountName: "",
    childAccountNumber: "",
    parentName: "",
    parentNumber: "",
    isShowLookupTable: false,
    lookupResults: [],
  });
  const [errorFlag, setErrorFlag] = useState(false);

  const actionsFormatter = (row, type) => {
    handleLookupResultSelection(row);
  };
  const expandedItems = [{ keyName: "Parent Name", valueName: "parentName", classNameOne: "m-b-16" }];
  const actionsFormatterMobile = (row) => {
    return (
      <Button
        variant="outline-primary"
        className="border-0 p-0"
        onClick={() => {
          handleLookupResultSelection(row);
        }}
      />
    );
  };

  const handleLookupResultSelection = (row) => {
    parentSelectionCallback(row);
    modalDisplayCallback(false);
  };

  const handleLookup = () => {
    const { parentName, parentNumber, childAccountName, childAccountNumber } = parentLookupData;
    const data = {
      acctNumber: childAccountNumber,
      acctName: childAccountName,
      parentNumber,
      parentName,
    };

    const payload = Object.fromEntries(Object.entries(data).filter(([key, value]) => value));

    dispatch(showSpinner());
    setParentLookupData({ ...parentLookupData, isShowLookupTable: false });
    parentLookupFetch(payload)
      .then((res) => {
        setParentLookupData({ ...parentLookupData, lookupResults: res, isShowLookupTable: true });
        setErrorFlag(false);
        dispatch(hideSpinner());
      })
      .catch((err) => {
        setParentLookupData({ ...parentLookupData, lookupResults: [], isShowLookupTable: true });
        setErrorFlag(true);
        console.error(err);
        dispatch(hideSpinner());
      });
  };

  const handleLookupFieldsChange = (event) => {
    const { id, value } = event.target;
    setParentLookupData({ ...parentLookupData, [id]: value });
  };

  const handleLookupModal = (isShow) => {
    modalDisplayCallback(isShow);
  };
  const renderDesktopParentLookupRows = (currentData) => {
    return currentData.map((row, idx) => {
      const { id } = row;
      return (
        <tr key={id ? id : idx} className={"table-root__body__tr"}>
          {parentLookupHeaders.map((col, index) => {
            return (
              <>
                {col.name === "Parent Name" && (
                  <td
                    className={"table-root__body__tr__td table-root__body__tr__td__text customer-txt customer-txt_val"}
                    key={index}
                  >
                    <span className="product-name-link" onClick={() => actionsFormatter(row)}>
                      <CustomTooltip placement="top" trigger="hover" text={`${row.parentName}`}>
                        <span>{displayDesktopRowItem(row, col)}</span>
                      </CustomTooltip>
                    </span>
                  </td>
                )}
                {col.name === "Parent Number" && (
                  <td
                    className={"table-root__body__tr__td table-root__body__tr__td__text customer-txt_val"}
                    key={index}
                  >
                    <span onClick={() => actionsFormatter(row)}>
                      <span>{displayDesktopRowItem(row, col)}</span>
                    </span>
                  </td>
                )}
              </>
            );
          })}
        </tr>
      );
    });
  };

  return (
    <>
      <Modal
        title="Parent Lookup"
        handleSave={() => {}}
        handleCancel={() => handleLookupModal(false)}
        sectionName={""}
        bodyClass={"account-lookup-search-form"}
        size={mobileView ? "sm" : "lg"}
      >
        <>
          <div className="container-fluid search-form-container border-0 parent-lookup-modal">
            <div className="search-form-container__fields">
              <div className="d-flex search-form-container__fields__msg">
                <div className="search-form-container__fields__msg--icon">
                  <img src={warning} alt={"warning-icon"} />
                </div>
                <div className="search-form-container__fields__msg--text">At least one input is required</div>
              </div>
              <form className="search-form-container__fields__form">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-5 col-lg-4 search-form-container__fields__form-group">
                    <InputField
                      type="text"
                      label="Parent Number"
                      id="parentNumber"
                      placeholder="Enter Number"
                      fieldClasses="form-control search-form-container__fields__form-group__item"
                      value={parentLookupData.parentNumber}
                      onChange={(e) => handleLookupFieldsChange(e)}
                      disabled={false}
                      isRequired={false}
                      maxLength={4}
                    />
                  </div>
                  <div className="col-12 col-sm-12 col-md-7 col-lg-8 search-form-container__fields__form-group">
                    <InputField
                      type="text"
                      label="Parent Name"
                      id="parentName"
                      placeholder="Enter Parent Name"
                      fieldClasses="form-control search-form-container__fields__form-group__item"
                      value={parentLookupData.parentName}
                      onChange={(e) => handleLookupFieldsChange(e)}
                      disabled={false}
                      isRequired={false}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-5 col-lg-4 search-form-container__fields__form-group">
                    <InputField
                      type="text"
                      label="Child Account Number"
                      id="childAccountNumber"
                      placeholder="Enter Child Account Number"
                      fieldClasses="form-control search-form-container__fields__form-group__item"
                      value={parentLookupData.childAccountNumber}
                      onChange={(e) => handleLookupFieldsChange(e)}
                      disabled={false}
                      isRequired={false}
                    />
                  </div>
                  <div className="col-12 col-sm-12 col-md-7 col-lg-8 search-form-container__fields__form-group">
                    <InputField
                      type="text"
                      label="Child Account Name"
                      id="childAccountName"
                      placeholder="Enter Child Account Name"
                      fieldClasses="form-control search-form-container__fields__form-group__item"
                      value={parentLookupData.childAccountName}
                      onChange={(e) => handleLookupFieldsChange(e)}
                      disabled={false}
                      isRequired={false}
                    />
                  </div>
                </div>
              </form>
              <div className="d-flex search-form-container__fields__btn">
                <Button
                  variant="outline-primary"
                  onClick={handleLookup}
                  disabled={
                    !parentLookupData.parentNumber &&
                    !parentLookupData.parentName &&
                    !parentLookupData.childAccountNumber &&
                    !parentLookupData.childAccountName
                  }
                >
                  Search
                </Button>
              </div>
            </div>
          </div>
          {parentLookupData.isShowLookupTable && (
            <DataTable
              tableHeader={parentLookupHeaders}
              tableBody={parentLookupData.lookupResults}
              renderDesktopRows={renderDesktopParentLookupRows}
              parentComponent={"parentLookup"}
              countTitle="Search Results"
              displaySearchFilter={false}
              displaySectionTwo={false}
              isSelectAllChecked={false}
              actionsFormatter={actionsFormatter}
              actionsFormatterMobile={actionsFormatterMobile}
              errorFlag={errorFlag}
            />
          )}
        </>
      </Modal>
    </>
  );
};

export default ParentLookup;
